/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LogFieldChangeItem } from '../models/LogFieldChangeItem';
import type { meta } from '../models/meta';
import type { refTableEnum } from '../models/refTableEnum';
import { request as __request } from '../core/request';

export class LoggingService {

    /**
     * Create a new Log Field Change
     * Creates a record based on data given
     * @result LogFieldChangeItem Successful operation
     * @throws ApiError
     */
    public static async createLogFieldChange({
        requestBody,
    }: {
        /**  object to be created **/
        requestBody: LogFieldChangeItem,
    }): Promise<LogFieldChangeItem> {
        const result = await __request({
            method: 'POST',
            path: `/server/logging/lfc`,
            body: requestBody,
            errors: {
                400: `Error: Update Failed`,
                403: `Error: Forbidden`,
                422: `Error: Unprocessable Entity`,
            },
        });
        return result.body;
    }

    /**
     * Log Change Field by ID.
     * Returns matching record
     * @result LogFieldChangeItem successful operation
     * @throws ApiError
     */
    public static async getLogChangeFieldById({
        id,
    }: {
        /** Record ID **/
        id: number,
    }): Promise<LogFieldChangeItem> {
        const result = await __request({
            method: 'GET',
            path: `/server/logging/lfc/${id}`,
            errors: {
                403: `Error: Forbidden`,
                404: `Error: Not Found`,
                422: `Error: Unprocessable Entity`,
            },
        });
        return result.body;
    }

    /**
     * Find multiple Log Field Change entries.  Filterable by title, Link.
     * Returns one or more matching records.  Sorty Options: id, name, table, ref_id, user_id, date, created, event, old_value, new_value
     * @result any successful operation
     * @throws ApiError
     */
    public static async getLogFieldChangeList({
        userId,
        createdStart,
        createdEnd,
        text,
        refTable,
        refId,
        event,
        excludeEvent,
        refField,
        oldVal,
        newVal,
        includeUser = false,
        page = 1,
        pageSize = 10,
        sort,
    }: {
        /** Find records associated with a given User **/
        userId?: number,
        /** Start time for range of record creation **/
        createdStart?: number,
        /** End time for range of record creation **/
        createdEnd?: number,
        /** Find records searching by text. **/
        text?: string,
        /** Reference Table **/
        refTable?: refTableEnum,
        /** Reference ID **/
        refId?: number,
        /** Reference event **/
        event?: 'field_change' | 'query_create' | 'login' | 'login_as' | 'entity_enable_disable' | 'update' | 'create' | 'delete',
        /** Exclude Specific Reference event **/
        excludeEvent?: 'field_change' | 'query_create' | 'login' | 'login_as' | 'entity_enable_disable' | 'update' | 'create' | 'delete',
        /** Reference Field **/
        refField?: string,
        /** Old Value **/
        oldVal?: string,
        /** New Value **/
        newVal?: string,
        /** Should user details be included in result? **/
        includeUser?: boolean,
        /** Page to begin results at **/
        page?: number,
        /** Number of results per page **/
        pageSize?: number,
        /** Sort Options - Comma delimited list of key:order. order optional - default ASC  **/
        sort?: string,
    }): Promise<{
        data?: Array<LogFieldChangeItem>,
        meta?: meta,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/server/logging/lfc/list`,
            query: {
                'userId': userId,
                'createdStart': createdStart,
                'createdEnd': createdEnd,
                'text': text,
                'refTable': refTable,
                'refId': refId,
                'event': event,
                'excludeEvent': excludeEvent,
                'refField': refField,
                'oldVal': oldVal,
                'newVal': newVal,
                'includeUser': includeUser,
                'page': page,
                'pageSize': pageSize,
                'sort': sort,
            },
            errors: {
                403: `Error: Forbidden`,
                422: `Error: Unprocessable Entity`,
            },
        });
        return result.body;
    }

}